<template>
  <el-dialog
    :close-on-click-modal="false"
    title="回单"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <span class="primary cur billBtn" v-show="billListData.length === 0" @click="addbill(0)">添加</span>
      <qx-card-form
        :title="'单据' + (index + 1)"
        v-for="(item, index) in billListData"
        :key="item.id"

      >
        <span slot="titleLeft">
          <span class="primary cur billBtn" v-show="originData.reciveState===1||originData.reciveState===4 " @click="addbill(index)">添加</span>
          <span class="error cur billBtn" v-show="originData.reciveState===1||originData.reciveState===4 " @click="delbill(index)">删除</span>
        </span>
        <billForm ref="billForm" :reciveNumber="item.reciveNumber" :file="item.file" />
      </qx-card-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        v-if="(originData.reciveState === 1 || originData.reciveState === 4) && checkPermpisions('3300212')"
        type="primary"
        @click="sub"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
<!--      <el-button-->
<!--          v-if="originData.reciveState && checkPermpisions('3300212')"-->
<!--          type="primary"-->
<!--          @click="sub"-->
<!--          :loading="subLoading || getDetailLoading"-->
<!--      >确 定</el-button>-->
    </section>
  </el-dialog>
</template>

<script>
import {
  orderReceiptQueryBill,
  orderReceiptUploadBill,
} from 'api/operate';
import billForm from './billForm';
export default {
  components: {
    billForm,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      billListData: [],
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      const listRes = await orderReceiptQueryBill({
        orderId: item.orderId,
      });
      this.getDetailLoading = false;
      if (!listRes.failed) {
        if (listRes.items.length === 0) {
          this.billListData = [{
            reciveNumber: '',
            file: [],
            id: Symbol('bill'),
          }];
        } else {
          this.billListData = listRes.items.map((item) => ({
            reciveNumber: item.reciveNumber,
            file: [{
              id: item.flowId,
              url: item.flowUrlAbsolute,
            }],
            id: item.id,
          }));
        }
      }
    },
    addbill (index) {
      this.billListData.splice(index + 1, 0, {
        receiptNumber: '',
        file: [],
        id: Symbol('bill'),
      });
    },
    delbill (index) {
      this.billListData.splice(index, 1);
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      const imgsStr = [];
      for (let i = 0; i < this.$refs.billForm.length; i++) {
        const subData = await this.$refs.billForm[i].sub();
        if (subData) {
          imgsStr.push({
            reciveNumber: subData.reciveNumber,
            flowId: subData.file[0].id,
            flowUrl: subData.file[0].url,
          });
        } else {
          return;
        }
      }
      this.subLoading = true;
      const res = await orderReceiptUploadBill({
        imgsStr: JSON.stringify(imgsStr),
        orderId: this.originData.orderId,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.billBtn {
  margin-left: 16px;
}
</style>
